/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ユーザー設定のボディリクエスト。
 * @export
 * @interface UserSettingRequestModel
 */
export interface UserSettingRequestModel {
    /**
     * 性別
     * * 0: 未回答
     * * 1: 男性
     * * 2:　女性
     * * 99: どちらでもない
     * @type {number}
     * @memberof UserSettingRequestModel
     */
    genderType: number;
    /**
     * 生まれた年
     * * -1: 未回答
     * @type {number}
     * @memberof UserSettingRequestModel
     */
    ageYear: number;
    /**
     * アプリ内のお気に入り作品に新しい エピソード が追加された通知設定フラグ
     * @type {boolean}
     * @memberof UserSettingRequestModel
     */
    isAppNoticeFavoriteSeriesUpdated: boolean;
    /**
     * メールでお気に入り作品に新しい エピソード が追加された通知設定フラグ
     * @type {boolean}
     * @memberof UserSettingRequestModel
     */
    isNoticeFavoriteSeriesUpdated: boolean;
    /**
     * メールで最近のお題をお知らせの通知設定フラグ
     * @type {boolean}
     * @memberof UserSettingRequestModel
     */
    isNoticePostNewsletter: boolean;
}

/**
 * Check if a given object implements the UserSettingRequestModel interface.
 */
export function instanceOfUserSettingRequestModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "genderType" in value;
    isInstance = isInstance && "ageYear" in value;
    isInstance = isInstance && "isAppNoticeFavoriteSeriesUpdated" in value;
    isInstance = isInstance && "isNoticeFavoriteSeriesUpdated" in value;
    isInstance = isInstance && "isNoticePostNewsletter" in value;

    return isInstance;
}

export function UserSettingRequestModelFromJSON(json: any): UserSettingRequestModel {
    return UserSettingRequestModelFromJSONTyped(json, false);
}

export function UserSettingRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSettingRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'genderType': json['genderType'],
        'ageYear': json['ageYear'],
        'isAppNoticeFavoriteSeriesUpdated': json['isAppNoticeFavoriteSeriesUpdated'],
        'isNoticeFavoriteSeriesUpdated': json['isNoticeFavoriteSeriesUpdated'],
        'isNoticePostNewsletter': json['isNoticePostNewsletter'],
    };
}

export function UserSettingRequestModelToJSON(value?: UserSettingRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'genderType': value.genderType,
        'ageYear': value.ageYear,
        'isAppNoticeFavoriteSeriesUpdated': value.isAppNoticeFavoriteSeriesUpdated,
        'isNoticeFavoriteSeriesUpdated': value.isNoticeFavoriteSeriesUpdated,
        'isNoticePostNewsletter': value.isNoticePostNewsletter,
    };
}

